/**
 * Round 142 - a link from the landing page (irtaki.net, a different site) carries the visitor's language as ?lang=en|ar. The app takes it ONCE,
 * at start-up: it becomes the chosen language (stored like the language toggle) and is removed from the address bar, so a later reload, a
 * bookmark or a shared link does not keep forcing it. Anything else in the address is kept. Unknown values are ignored (and left alone).
 */
export function takeLanguageFromUrl(known: readonly string[]): string | null {
  try {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get('lang');
    const code = raw ? raw.toLowerCase() : '';
    if (!code || !known.includes(code)) return null;
    url.searchParams.delete('lang');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    return code;
  } catch {
    return null;
  }
}
